import React from 'react';
import { Card, Row, Col, ProgressBar } from 'react-bootstrap';
import { FaChartBar, FaFileAlt } from 'react-icons/fa';

const DashboardMetrics = ({ stats }) => {
    return (
        <Row className="g-4 mb-4">
            {/* Traffic Stats */}
            <Col lg={8}>
                <Card className="shadow-sm border-0 h-100">
                    <Card.Header className="bg-white border-0 py-3">
                        <h5 className="mb-0 d-flex align-items-center">
                            <FaChartBar className="me-2 text-primary" /> Traffic Overview (Last 24h)
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-3">
                            <Col md={3} className="text-center border-end">
                                <div className="text-muted small mb-1">Total API Calls</div>
                                <h3 className="mb-0 fw-bold">{stats.traffic.totalRequests}</h3>
                            </Col>
                            <Col md={3} className="text-center border-end">
                                <div className="text-muted small mb-1">Success Rate</div>
                                <h3 className="mb-0 text-success fw-bold">{100 - parseFloat(stats.traffic.errorRate)}%</h3>
                            </Col>
                            <Col md={3} className="text-center border-end">
                                <div className="text-muted small mb-1">Total Errors</div>
                                <h3 className="mb-0 text-danger fw-bold">{stats.traffic.errors}</h3>
                            </Col>
                            <Col md={3} className="text-center">
                                <div className="text-muted small mb-1">Avg. Response</div>
                                <h3 className="mb-0 text-info fw-bold">{Math.round(stats.traffic.avgLatency)}ms</h3>
                            </Col>
                        </Row>
                        <div className="mt-4">
                            <div className="d-flex justify-content-between small mb-1">
                                <span>System Error Load</span>
                                <span className={stats.traffic.errorRate > 10 ? 'text-danger fw-bold' : 'text-success'}>
                                    {stats.traffic.errorRate}%
                                </span>
                            </div>
                            <ProgressBar
                                variant={stats.traffic.errorRate > 10 ? 'danger' : 'success'}
                                now={parseFloat(stats.traffic.errorRate)}
                                style={{ height: '8px' }}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            {/* Application Enrollment Summary */}
            <Col lg={4}>
                <Card className="shadow-sm border-0 h-100">
                    <Card.Header className="bg-white border-0 py-3">
                        <h5 className="mb-0 d-flex align-items-center">
                            <FaFileAlt className="me-2 text-warning" /> Enrollment
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        <Row className="text-center mb-3">
                            <Col xs={6} className="border-end">
                                <div className="text-muted small">Total</div>
                                <h4 className="fw-bold mb-0">{stats.applications.totalApplications}</h4>
                            </Col>
                            <Col xs={6}>
                                <div className="text-muted small text-success">Paid</div>
                                <h4 className="fw-bold text-success mb-0">{stats.applications.paid}</h4>
                            </Col>
                        </Row>
                        <div className="p-3 bg-light rounded text-center">
                            <div className="small text-muted mb-1">Conversion Rate</div>
                            <h4 className="mb-0 fw-bold">
                                {stats.applications.totalApplications > 0
                                    ? ((stats.applications.paid / stats.applications.totalApplications) * 100).toFixed(0)
                                    : 0}%
                            </h4>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardMetrics;
